import { init, reactRouterV5Instrumentation } from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import type { Integration } from "@sentry/types";
import type { History } from "history";

import { isProduction, isProductionBundle, isSandbox } from "@shared/utils/fullscriptEnv";

import { beforeSend } from "./beforeSend";

interface Props {
  tracesSampleRate?: number;
  history?: History;
}

const getIntegrations = (history: History): Integration[] => {
  // Don't enable transactions in staging, sandbox, development or test
  if (!isProduction()) return [];

  // Allows checkout, oauth, unsubscribe etc to work
  // Required to support SPAs that don't use ReactRouter
  if (!history) {
    return [new Integrations.BrowserTracing()];
  }

  return [
    new Integrations.BrowserTracing({
      routingInstrumentation: reactRouterV5Instrumentation(history),
    }),
  ];
};

const environment = () => {
  if (isProduction()) {
    return "production";
  } else if (isSandbox()) {
    return "sandbox";
  } else if (process.env.FORCE_ENABLE_SENTRY === "true") {
    return "development";
  } else {
    return "staging";
  }
};

const initSentry = ({ tracesSampleRate, history }: Props = {}) => {
  init({
    dsn: "https://b1e6050ac9de430b807ad68a57ea5816@o927579.ingest.sentry.io/5878763",
    integrations: getIntegrations(history),
    tracesSampleRate: tracesSampleRate || 1.0,
    enabled: process.env.FORCE_ENABLE_SENTRY === "true" || isProductionBundle(),
    environment: environment(),
    release: process.env.CI_COMMIT_SHA,
    denyUrls: [
      // browser extensions
      /extension:\/\//gi,
      /^file:\/\//gi,
    ],
    beforeSend,
  });
};

export { initSentry };
